module.exports = __webpack_public_path__ + "img/shopee.88749f47.png";